"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCondition = exports._createCondition = void 0;
const _createCondition = (conditionalQuestionLabel, scope, ...args) => {
    const [answer, operator, question] = args;
    return {
        scope: { create: scope },
        conditionalQuestion: {
            connect: {
                label: conditionalQuestionLabel,
            },
        },
        comparativeValue: answer,
        operator: operator === "===" ? "EQUAL_TO" : "NOT_EQUAL_TO",
        determiningQuestion: {
            connect: {
                label: question.label,
            },
        },
    };
};
exports._createCondition = _createCondition;
const createCondition = (conditions, scope, conditionalQuestionLabel, ...args) => {
    conditions.push((0, exports._createCondition)(conditionalQuestionLabel, scope, ...args));
};
exports.createCondition = createCondition;
